// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimEvaluationRow-cls1_S8I","cls2":"ClaimEvaluationRow-cls2_OvF ClaimEvaluationRow-cls1_S8I"};